module.exports = __webpack_public_path__ + "img/02.68b01de8.svg";